import { SET, RESET_STATE } from "@/stores/CommumActionTypes";

const actions = {
	[SET]: ({ commit }, menu) =>
	{
		commit(SET, menu);
	},
	[RESET_STATE]: ({ commit }) => commit(RESET_STATE),
};

export default { actions };
